/** Assistant-hint dismissals: `assistantHint.dismissed.<userId>.<hintId>`. */
export const ASSISTANT_HINT_DISMISSED_PREFIX = 'assistantHint.dismissed.'

/** Per-user UI preferences (keyed by user id) that survive logout. */
const KEEP_ON_LOGOUT_PREFIXES = [ASSISTANT_HINT_DISMISSED_PREFIX]

/** Clears localStorage on logout, keeping per-user UI preferences. */
export const clearLocalStorageOnLogout = () => {
  try {
    const keys = Array.from({ length: localStorage.length }, (_, i) => localStorage.key(i))
    for (const key of keys) {
      if (key && !KEEP_ON_LOGOUT_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        localStorage.removeItem(key)
      }
    }
  } catch {
    // Storage unavailable: nothing to clear.
  }
}
